import React from 'react';
import { ImgSec } from './CoupleItemStyle';

const fadeVariants = {
  hidden: { opacity: 0, scale: 0.9 },
};

type Props = {
  imgURL?: string;
  name: string;
  dir: string;
  bgColor?: string;
  textColor?: string;
  children?: JSX.Element;
};
function ImgCard({ imgURL, dir, children }: Props) {
  return (
    <ImgSec
      imgURL={imgURL}
      initial="hidden"
      animate={{ opacity: 1, scale: 1 }}
      exit="hidden"
      transition={{ duration: 0.2 }}
      variants={fadeVariants}
      dir={dir}
    >
      {children}
    </ImgSec>
  );
}

export default ImgCard;
